import { createBrowserHistory } from 'history';

// In order to allow non-components (e.g. the API class in 'utils.js`) to use
// react-router's `history`, we define a custom, importable `history` to be
// used by <Route> in `App.js` (in place of the default one) and anywhere it may
// be needed.
// See https://stackoverflow.com/a/44163399.
const history = createBrowserHistory();
export default history;
